import {legacy_createStore as createStore, applyMiddleware} from 'redux';
import rootReducer from './reducers';
import types from './store/person/types';
//import { composeWithDevTools } from 'redux-devtools-extension';
//import { thunk } from 'redux-thunk';

const sessionStorageMiddleware = store => next => action => {
  const result = next(action);
  
  if (action.type === types.UPDATE_PERSON || action.type === types.RESET_PERSON) {
    const state = store.getState();
    sessionStorage.setItem('person', JSON.stringify(state.person));
  }

  return result;
};

const savedPerson = JSON.parse(sessionStorage.getItem('person'));

const preloadedState = {
  person: savedPerson || {},
};

const store = createStore(rootReducer, preloadedState, applyMiddleware(sessionStorageMiddleware));

export default store;